export const getAlertsState = store => store && store.alerts;
export const getAlerts = store => getAlertsState(store).data;
